/**
 * rw-signup.js — Restwell Klaviyo email signup
 *
 * Wires every Restwell `.klaviyo-form` (the "Stay in the Know" CTA section
 * and the Restwell footer) to Klaviyo's client subscription API, adding the
 * subscriber to the RestWell list. Loaded from snippets/restwell-footer.liquid
 * so it is present on every page that renders a Restwell signup form.
 */
(function () {
  'use strict';

  if (window.__rwSignupInit) return;
  window.__rwSignupInit = true;

  var COMPANY_ID = 'SFzmnr';
  var LIST_ID = 'TxvWkn'; // Klaviyo list: RestWell
  var ENDPOINT =
    'https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID;

  var SUCCESS_MESSAGE = 'You’re on the list — we’ll be in touch.';
  var ERROR_MESSAGE = 'Something went wrong — please try again.';

  function customSource(form) {
    return form.classList.contains('restwell-footer__form')
      ? 'Restwell Footer'
      : 'Restwell Landing';
  }

  function setError(form, message) {
    var error = form.querySelector('.rw-signup__error');
    if (!message) {
      if (error) error.remove();
      return;
    }
    if (!error) {
      error = document.createElement('p');
      error.className = 'rw-signup__error';
      error.setAttribute('role', 'alert');
      form.appendChild(error);
    }
    error.textContent = message;
  }

  function showSuccess(form) {
    var row = form.querySelector(
      '.rw-cta__form-row, .restwell-footer__form-row'
    );
    var success = document.createElement('p');
    success.className = 'rw-signup__success';
    success.setAttribute('role', 'status');
    success.textContent = SUCCESS_MESSAGE;
    if (row) {
      row.replaceWith(success);
    } else {
      form.innerHTML = '';
      form.appendChild(success);
    }
    setError(form, null);
  }

  function subscribe(form, email) {
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: customSource(form),
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: LIST_ID } }
        }
      }
    };

    return fetch(ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-10-15'
      },
      body: JSON.stringify(payload)
    });
  }

  function handleSubmit(evt) {
    var form = evt.target;
    if (!form.classList || !form.classList.contains('klaviyo-form')) return;

    evt.preventDefault();

    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var email = input ? input.value.trim() : '';
    if (!email) return;

    setError(form, null);
    var originalText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Sending…';
    }

    subscribe(form, email)
      .then(function (response) {
        if (!response.ok) throw new Error('Klaviyo ' + response.status);
        showSuccess(form);
      })
      .catch(function () {
        if (button) {
          button.disabled = false;
          button.textContent = originalText;
        }
        setError(form, ERROR_MESSAGE);
      });
  }

  document.addEventListener('submit', handleSubmit);
})();
